import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

import SecureRoute from "shared/services/AuthDecorator/SecureRoute";

import { AdminRoles } from "shared/types/Admin";

import { routes } from "./constants";

const AdminLayout = lazy(() => import("shared/templates/Layouts/AdminLayout"));

const AuthorizationPage = lazy(() => import("./Pages/Auth"));
const DashboardPage = lazy(() => import("./Pages/Dashboard"));
const AdminsPage = lazy(() => import("./Pages/Admins"));
const UsersPage = lazy(() => import("./Pages/Users"));
const IssuancesPage = lazy(() => import("./Pages/Issuances"));
const CreateIssuancePage = lazy(() => import("./Pages/Issuances/Create"));
const ViewIssuancePage = lazy(() => import("./Pages/Issuances/View"));
const EditIssuancePage = lazy(() => import("./Pages/Issuances/Edit"));
const LogoutPage = lazy(() => import("./Pages/Logout"));

const AdminRoutes = () => {
	const getPublicRoutes = () => [
		<Route
			key={routes.admin.auth.getElementKey()}
			path={routes.admin.auth.getPath()}
			element={
				<Suspense>
					<AuthorizationPage />
				</Suspense>
			}
		/>
	];

	const getSecuredRoutes = () => [
		<Route
			key={routes.admin.dashboard.getElementKey()}
			path={routes.admin.dashboard.getPath()}
			element={
				<Suspense>
					<DashboardPage />
				</Suspense>
			}
		/>,
		<Route
			key={routes.admin.admins.getElementKey()}
			path={routes.admin.admins.getPath()}
			element={
				<Suspense>
					<AdminsPage />
				</Suspense>
			}
		/>,
		<Route
			key={routes.admin.users.getElementKey()}
			path={routes.admin.users.getPath()}
			element={
				<Suspense>
					<UsersPage />
				</Suspense>
			}
		/>,
		<Route
			key={routes.admin.issuance.list.getElementKey()}
			path={routes.admin.issuance.list.getPath()}
			element={
				<Suspense>
					<IssuancesPage />
				</Suspense>
			}
		/>,
		<Route
			key={routes.admin.issuance.add.getElementKey()}
			path={routes.admin.issuance.add.getPath()}
			element={
				<Suspense>
					<CreateIssuancePage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.admin.issuance.getElementKey()}/:id`}
			path={`${routes.admin.issuance.getPath()}/:id`}
			element={
				<Suspense>
					<ViewIssuancePage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.admin.issuance.getElementKey()}/:id/edit`}
			path={`${routes.admin.issuance.getPath()}/:id/edit`}
			element={
				<Suspense>
					<EditIssuancePage />
				</Suspense>
			}
		/>,
		<Route
			key={routes.admin.logout.getElementKey()}
			path={routes.admin.logout.getPath()}
			element={
				<Suspense>
					<LogoutPage />
				</Suspense>
			}
		/>
	];

	return [
		<Route
			key="admin-routes-root"
			path={routes.admin.getPath()}
			element={
				<Suspense>
					<AdminLayout />
				</Suspense>
			}
		>
			{getPublicRoutes()}
			<Route element={<SecureRoute roles={[AdminRoles.ADMIN]} />}>{getSecuredRoutes()}</Route>
		</Route>

		// 	{getPublicRoutes()}
		// 	<Route element={<SecureRoute roles={[AdminRoles.ADMIN]} />}>{getSecuredRoutes()}</Route>
	];
};

export default AdminRoutes;
